import { TALKDESK_LOGO } from '../../constants/images'
import { LOGO_ALTERNATE_TEXT } from '../../constants/ui.labels'
import Image from '@talkdesk/cobalt-react-image'
import Flex from '@talkdesk/cobalt-react-flex'
import { constantBuilder } from '../../utils/index'

const DisclaimerHeader = ({
  brandingSettings: {
    branding: { assets, name }
  }
}) => (
  <Flex direction="column" alignX="center" paddingBottom={6}>
    {assets && (
      <Image
        src={TALKDESK_LOGO(assets)}
        alt={constantBuilder(LOGO_ALTERNATE_TEXT, { name })}
        height={32}
        width={160}
      />
    )}
  </Flex>
)

export default DisclaimerHeader
